import { cn, TypeIs } from "../helper/helper";
import { CSSProperties } from "react";
// import { CopyText } from "../copyCheck";
import RazorCopyTextTwo from "../razorCopyText/RazorCopyText";
import { SN } from "../@types/global";

type TxProp = {
  reference?: string;
  hideCopy?: boolean;
  textToCopy?: SN;
  className?: CSSProperties;
  outerCopy?: boolean;
};
const RazorCopyText = ({
  reference,
  hideCopy = false,
  textToCopy,
  className,
  outerCopy,
}: TxProp) => {
  return (
    <div className={cn("trx-ref-comp", className)}>
      {!hideCopy ? (
        <RazorCopyTextTwo
          visibility={outerCopy}
          clickable={outerCopy}
          // text={TypeIs.custom<string>(reference)}
          text={reference}
          copyValue={textToCopy || ""}
        />
      ) : (
        <p>{reference}</p>
      )}
    </div>
  );
};
export default RazorCopyText;
